import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["styles"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SpinnerIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: styles["lds-spinner"] || "lds-spinner",
    width: "63",
    height: "63",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "0 0"
    }
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "47",
    y: "24.5",
    rx: "4.7",
    ry: "2.45",
    width: "6",
    height: "15",
    fill: "currentColor",
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })));
});

var COLOR_TO_SIZE_MAPPING = {
  darkest: "text-darkest",
  muted: "text-muted",
  lightest: "text-lightest",
  body: "text-body"
};
var Spinner = function Spinner(_a) {
  var _b = _a.size,
    size = _b === void 0 ? 96 : _b,
    _c = _a.isCentered,
    isCentered = _c === void 0 ? false : _c,
    _d = _a.color,
    color = _d === void 0 ? "darkest" : _d;
  return /*#__PURE__*/React.createElement(SpinnerIcon, {
    className: classnames(COLOR_TO_SIZE_MAPPING[color], {
      "absolute inset-0 m-auto": isCentered
    }),
    "data-test-role": "loading-spinner",
    width: size,
    height: size
  });
};
Spinner.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isCentered: PropTypes.bool,
  color: PropTypes.oneOf(Object.keys(COLOR_TO_SIZE_MAPPING))
};

var Loader = function Loader(_a) {
  var _b = _a.children,
    children = _b === void 0 ? null : _b,
    _c = _a.isLoaded,
    isLoaded = _c === void 0 ? false : _c,
    _d = _a.spinnerSize,
    spinnerSize = _d === void 0 ? 96 : _d;
  return isLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(Spinner, {
    size: spinnerSize,
    isCentered: true
  });
};
Loader.propTypes = {
  children: PropTypes.node,
  isLoaded: PropTypes.bool,
  spinnerSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

var LoadingOverlay = function LoadingOverlay(_a) {
  var _b = _a.isLoaded,
    isLoaded = _b === void 0 ? false : _b,
    children = _a.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, !isLoaded && /*#__PURE__*/React.createElement("div", {
    className: "z-50 absolute w-full h-full",
    style: {
      backgroundColor: "rgba(255,255,255,0.75)"
    },
    "data-test-role": "loading-overlay"
  }, /*#__PURE__*/React.createElement(Spinner, {
    isCentered: true
  })), children);
};
LoadingOverlay.propTypes = {
  isLoaded: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export { Loader, LoadingOverlay, Spinner };
//# sourceMappingURL=index.es.js.map
